import React, { forwardRef, useImperativeHandle, useState } from "react";
import TransactionItemOverview from "./TransactionItemOverview";

export default forwardRef(({ transactionType, items = [] }, ref) => {
    useImperativeHandle(ref, () => ({
        filterTransactionsByCategory: (categoryId) => {
            filterTransactionsByCategory(categoryId);
        },
        clearFilters: () => {
            clearFilters();
        },
        setItems: (items) => {
            setOriginalTransactions(items);
            setTransactions(items);
        }
    }));

    const [originalTransactions, setOriginalTransactions] = useState(items);
    const [transactions, setTransactions] = useState(items);

    //We use that component in two places
    //1. In the balance page, with a ref - to filter by category
    //2. In the insights page, without a ref - to show all transactions
    //if we use a ref we cannot change the transactions array when moving between months - so we use the orginal items prop
    const transactionToShow = ref? transactions : items;

    const filterTransactionsByCategory = (categoryId) => {
        setTransactions(originalTransactions.filter((item) => item.categoryId === categoryId));
    };

    const clearFilters = () => {
        setTransactions(originalTransactions);
    };

    return (
        <div>
            <p
                style={{
                    fontWeight: "bold",
                    textAlign: "right",
                    marginRight: "5%",
                    marginTop: "2%",
                    fontSize: "16px"
                }}
            ></p>
            <div style={{ overflowY: "scroll", maxHeight: "200px" }}>
                {transactionToShow.map((item) => {
                    return (
                        <div key={item.id} style={{ marginBottom: "3%" }}>
                            <TransactionItemOverview
                                item={item}
                                transactionType={transactionType}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
});